import React, { useEffect, Fragment, useState } from 'react';
import clsx from 'clsx';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import useChatContext from '../../../hooks/useChatContext/useChatContext';
import useParticipants from '../../../hooks/useParticipants/useParticipants';
import OpenEndMeetingForAll from '../../OpenEndMeetingForAll/OpenEndMeetingForAll';
import { useHistory } from 'react-router-dom';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      background: theme.brand,
      color: 'white',
      '&:hover': {
        background: '#600101',
      },
      width: ' 85px !important',
    },
  })
);
// function DisconnectParticipant() {

// }
export default function EndMeetingForAll(props: { className?: string }) {
  const history = useHistory();
  const { messages, conversation } = useChatContext();
  const classes = useStyles();
  const participants = useParticipants();
  const { room } = useVideoContext();
  const [isDialpadModalOpen, setIsDialpadModalOpen] = useState<boolean>(false);
  const closeDialpadModal = () => {
    setIsDialpadModalOpen(false);
  };
  const openDialpadModal = () => {
    setIsDialpadModalOpen(true);
  };
  // useEffect(() => {
  //   // //console.log(participants);
  //   // //console.log(room?.localParticipant);
  //   if (messages.length > 0 && room?.localParticipant != null) {
  //     // //console.log(messages[messages.length - 1]?.body?.split('/')[1], 'checking wala data');
  //     if (
  //       messages[messages.length - 1]?.body?.split('/')[0] == 'disconnected' &&
  //       messages[messages.length - 1]?.body?.split('/')[1] == room?.localParticipant.sid
  //     ) {
  //       // if (audioTrack) {
  //       //   //console.log(audioTrack.isEnabled);
  //       //   audioTrack.disable();

  //       // }
  //       // //console.log(messages[messages.length - 1]?.body, 'chakdasdna');
  //       Disconnect();
  //       // //console.log("hello")
  //     }
  //   }
  // }, [messages]);

  const Disconnect = () => {
    history.replace('/end');
    room!.disconnect();
  };
  const DisconnectWithModal = () => {
    // history.replace('/end');
    // room!.disconnect();
    setIsDialpadModalOpen(true);
  };
  return (
    <Fragment>
      <Button
        onClick={() => DisconnectWithModal()}
        className={clsx(classes.button, props.className)}
        data-cy-disconnect
      >
        End Call
      </Button>
      <Dialog open={isDialpadModalOpen} onClose={closeDialpadModal} className="dailpadhassan">
        <Button onClick={closeDialpadModal} id="closebutton">
          X
        </Button>
        {/* <DialogTitle>Make A Call</DialogTitle> */}
        <DialogContent>
          {/* You can place the content of your dialpad modal here */}
          <OpenEndMeetingForAll />
        </DialogContent>
      </Dialog>
    </Fragment>
  );
}
